import React, { Component } from 'react';
import config from '../../config';

class GlobalFooter extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount(){
    this.accordion = {
      init: function(config) {

        var self = this;

        function createEvents() {
          var windowSize = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          if (windowSize <= 767){
            self.container = config.container;
            self.originalHtml = document.querySelector(self.container).innerHTML;
            self.containerClassName = document.querySelector(self.container).className;
            if (self.container != "" && self.containerClassName != "active"){
              document.querySelector(self.container).className = "active";
              self.events();
            };
          } else {
            self.reset();
          }
        };

        createEvents();

        window.onresize = function(){
          createEvents();
        };

      },
      reset: function(){
        if (document.querySelector(this.container) != null && document.querySelector(this.container).className){
          document.querySelector(this.container).className = '';
          document.querySelector(this.container).innerHTML = this.originalHtml;
          for(var i = 0; i < document.querySelectorAll(this.container + " > li > ul").length; i++){
            document.querySelectorAll(this.container + " > li > ul")[i].style.display = "";
            document.querySelectorAll(this.container + " > li > h2")[i].className = "";
            document.querySelectorAll(this.container + " > li > h2 span.fa")[i].className = "fa fa-chevron-down";
          };
        };
      },
      events: function(){
        this.accordionItems = document.querySelectorAll(this.container + ".active > li");
        for ( var i = 0; i < this.accordionItems.length; i++ ) {
          var self = this;
          this.firsChild( this.accordionItems[i], 'H2' )
          .onclick = function () {
            var content = this.parentNode.querySelector("ul");
            for ( var i = 0; i < self.accordionItems.length; i++ ) {
              var contentItem = self.accordionItems[i].querySelector("ul");
              self.accordionItems[i].querySelector("h2").className = "";
              self.accordionItems[i].querySelector("h2").querySelector(".fa").className = "fa fa-chevron-down";
              if (!self.isHidden(contentItem) && contentItem != content){
                contentItem.style.display = "none";
              };
            };
            content.style.display = ( self.isHidden(content) ) ? 'block' : 'none';
            this.className = ( self.isHidden(content) ) ? '' : 'open-item';
            this.querySelector(".fa").className = ( self.isHidden(content) ) ? 'fa fa-chevron-down' : 'fa fa-chevron-left';
          };
        };

      },
      firsChild: function( element, tagName ) {
        for ( var i = 0; i < element.childNodes.length; i++ ) {
          if ( element.childNodes[i].nodeName == tagName ) {
            return element.childNodes[i];
          };
        };
      },
      isHidden: function(element) {
        var style = window.getComputedStyle(element);
        return (style.display === 'none')
      }
    };
  }

  componentDidMount() {
    this.accordion.init({container: "#footer-accordion"});
  }


  render() {
    return (
      <footer className="footer">
        <div className="footer-container">
          <ul id="footer-accordion" >
            <li>
              <h2>Products <span className="fa fa-chevron-down"></span></h2>
              <ul>

                <li><a href={`${config.bwHost}/infowide.jsp?id=59891`}>Marine Forecasts</a></li>
                <li><a href={`${config.bwHost}/passage.jsp`}>Passage Forecasts</a></li>
                <li><a href={`${config.bwHost}/info.jsp?id=27650`}>Weather Widgets</a></li>
                <li><a href={`${config.bwHost}/info.jsp?id=21742`}>Marine Charts</a></li>
                <li><a href="/news/">News</a></li>
              </ul>
            </li>
            <li>
              <h2>Tutorials <span className="fa fa-chevron-down"></span></h2>
              <ul>
                <li><a href={`${config.bwHost}/infowide.jsp?id=21913`}>Buoyweather 101</a></li>
                <li><a href={`http://benefits.buoyweather.com/app/`}>Buoyweather Mobile</a></li>
                <li><a href={`${config.bwHost}/infowide.jsp?id=63286`}>Saving Favorites</a></li>
              </ul>
            </li>
            <li>
              <h2>Support <span className="fa fa-chevron-down"></span></h2>
              <ul>
                <li><a href={`https://support.buoyweather.com/hc/en-us`}>Support Center</a></li>
                <li><a href={`${config.bwHost}/infowide.jsp?id=67414`}>Premium Benefits</a></li>
                <li><a href={`${config.bwHost}/sitemap/`}>Site Map</a></li>
                <li><a href={`${config.bwHost}/gift-cards/`}>Gift Cards</a></li>
              </ul>
            </li>
            <li>
              <h2>Company <span className="fa fa-chevron-down"></span></h2>
              <ul>
                <li><a href={`${config.bwHost}/info.jsp?id=21739`}>About Us</a></li>
                <li><a href={`${config.bwHost}/advertising/mediakit/`}>Advertise</a></li>
                <li><a href={`${config.bwHost}/infowide.jsp?id=38951`}>Marine Consulting</a></li>
                <li><a href={`${config.bwHost}/infowide.jsp?id=40549`}>Historical Weather</a></li>
                <li><a href={`${config.bwHost}/partners/`}>Partners</a></li>
              </ul>
            </li>
            <li>
              <h2>Network <span className="fa fa-chevron-down"></span></h2>
              <ul>
                <li><a href="http://www.surfline.com/">Surf Reports</a></li>
                <li><a href="http://www.beachlive.com/">Beach Weather</a></li>
                <li><a href="http://www.fishtrack.com/">Deep Sea Fishing</a></li>
                <li><a href="http://www.surfaidinternational.org/">Surf/Aid</a></li>
                <li><a href="http://www.aframephoto.com/">Ocean Stock Photos</a></li>
              </ul>
            </li>
          </ul>
          <div className="company-details" >
            <h2>The Global Marine Forecasting Solution</h2>
            <p>
              <a href="http://www.facebook.com/buoyweather" target="_blank" className="fa fa-facebook-square"></a>
              <a href="http://twitter.com/buoyweather" target="_blank" className="fa fa-twitter-square"></a>
              <a href="https://plus.google.com/118377942982500260636/posts" target="_blank" className="fa fa-google-plus-square"></a>
            </p>
            <p><a href={`${config.bwHost}/terms-of-use`} target="_blank">Terms of Use</a> &#47; <a href={`${config.bwHost}/privacy-policy`} target="_blank">Privacy Policy</a></p>
            <p>&#169; {new Date().getFullYear()} Surfline/Wavetrak, Inc.</p>
          </div>
        </div>
      </footer>
    );
  }
}

export default GlobalFooter;



// WEBPACK FOOTER //
// ./src/components/GlobalFooter/GlobalFooter.js